import { useNavigate, useParams } from 'react-router-dom'
import { AppSidebar } from 'wss3-forge'
import {
  Document20Regular,
  Grid20Regular,
  Play20Regular,
  Settings20Regular,
  Code20Regular,
  Translate20Regular,
  Key20Regular,
  Person20Regular,
  People20Regular,
  Cart20Regular,
  Money20Regular,
  Location20Regular,
  Map20Regular,
  Building20Regular,
  VehicleCar20Regular,
  Briefcase20Regular,
  Trophy20Regular,
  Star20Regular,
  Shield20Regular,
  Bug20Regular,
  Question20Regular,
  Book20Regular,
  Lightbulb20Regular,
  Wrench20Regular,
  Link20Regular,
  ArrowSync20Regular,
  Flash20Regular,
  Chat20Regular,
  Phone20Regular,
  Mail20Regular,
  Calendar20Regular,
  Clock20Regular,
  Cube20Regular,
  Box20Regular,
  Image20Regular,
  Video20Regular,
  MusicNote220Regular,
  Games20Regular,
  Database20Regular
} from '@fluentui/react-icons'
import type { DocStructure } from '../lib/docs'
import type { ReactElement } from 'react'

// Icon mapping for dynamic icon rendering
const ICON_MAP: Record<string, ReactElement> = {
  'Play20Regular': <Play20Regular />,
  'Settings20Regular': <Settings20Regular />,
  'Code20Regular': <Code20Regular />,
  'Document20Regular': <Document20Regular />,
  'Translate20Regular': <Translate20Regular />,
  'DatabaseMultiple20Regular': <Database20Regular />,
  'Database20Regular': <Database20Regular />,
  'Command20Regular': <Code20Regular />,
  'Key20Regular': <Key20Regular />,
  'Person20Regular': <Person20Regular />,
  'People20Regular': <People20Regular />,
  'Cart20Regular': <Cart20Regular />,
  'Money20Regular': <Money20Regular />,
  'Location20Regular': <Location20Regular />,
  'Map20Regular': <Map20Regular />,
  'Building20Regular': <Building20Regular />,
  'Vehicle20Regular': <VehicleCar20Regular />,
  'Briefcase20Regular': <Briefcase20Regular />,
  'Trophy20Regular': <Trophy20Regular />,
  'Star20Regular': <Star20Regular />,
  'Shield20Regular': <Shield20Regular />,
  'Bug20Regular': <Bug20Regular />,
  'Question20Regular': <Question20Regular />,
  'Book20Regular': <Book20Regular />,
  'Lightbulb20Regular': <Lightbulb20Regular />,
  'Wrench20Regular': <Wrench20Regular />,
  'Link20Regular': <Link20Regular />,
  'ArrowSync20Regular': <ArrowSync20Regular />,
  'Flash20Regular': <Flash20Regular />,
  'Chat20Regular': <Chat20Regular />,
  'Phone20Regular': <Phone20Regular />,
  'Mail20Regular': <Mail20Regular />,
  'Calendar20Regular': <Calendar20Regular />,
  'Clock20Regular': <Clock20Regular />,
  'Cube20Regular': <Cube20Regular />,
  'Box20Regular': <Box20Regular />,
  'Image20Regular': <Image20Regular />,
  'Video20Regular': <Video20Regular />,
  'Music20Regular': <MusicNote220Regular />,
  'Gamepad20Regular': <Games20Regular />
}

function getIcon(iconName: string | null | undefined): ReactElement {
  if (!iconName) return <Document20Regular />
  return ICON_MAP[iconName] || <Document20Regular />
}

interface DocsSidebarProps {
  structure: DocStructure | null
  mode?: 'inline' | 'drawer'
  open?: boolean
  onClose?: () => void
}

export function DocsSidebar({ structure, mode = 'inline', open, onClose }: DocsSidebarProps) {
  const navigate = useNavigate()
  const { pluginSlug, sectionSlug, pageSlug } = useParams()

  if (!structure) return null

  // First section: All documentation link
  const allDocsSection = {
    items: [{
      id: 'all-docs',
      label: 'All documentation',
      icon: <Grid20Regular />
    }]
  }

  // Plugin sections with dynamic icons
  const pluginSections = structure.sections.map(section => ({
    title: section.title,
    items: section.pages.map(page => ({
      id: `${section.slug}/${page.slug}`,
      label: page.title,
      icon: getIcon(page.icon_name)
    }))
  }))

  const sections = [allDocsSection, ...pluginSections]

  const activeId = sectionSlug && pageSlug ? `${sectionSlug}/${pageSlug}` : undefined

  const handleNavigate = (id: string) => {
    if (id === 'all-docs') {
      navigate('/')
    } else {
      navigate(`/${pluginSlug}/${id}`)
    }
    onClose?.()
  }

  return (
    <AppSidebar
      mode={mode}
      open={open}
      onClose={onClose}
      showHeader={false}
      showSearch={false}
      sections={sections}
      activeId={activeId}
      onNavigate={handleNavigate}
      width={280}
    />
  )
}
